import React, { ChangeEvent } from 'react';
import { UseFormReturn } from 'react-hook-form';

import styles from './CSVField.module.css';

type Props = {
  form: UseFormReturn<any>;
  id: string;
  onSubmit: () => void;
  onClose: () => void;
  onInput: (event: ChangeEvent<HTMLInputElement>) => void;
  children: React.ReactNode;
};

const CSVField: React.FC<Props> = ({
  form,
  id,
  onSubmit,
  onClose,
  onInput,
  children,
}) => (
  <>
    <form onSubmit={form.handleSubmit(onSubmit, onClose)}>
      <div>
        <input
          {...form.register(id)}
          type={'file'}
          accept={'.csv'}
          onInput={onInput}
          className={styles.field__file}
          id={id}
        />
        <label className={styles.field__fileWrapper} htmlFor={id}>
          {children}
        </label>
      </div>
    </form>
  </>
);

export default CSVField;
